import styled, { keyframes } from "styled-components";

export const LoadingDotWrapper = styled.section`
	position: relative;
	min-height: 100px;
`;

const LoadingText = keyframes`
	0% {
		content: "Loading";
	}

	25% {
		content: "Loading.";
	}

	50% {
		content: "Loading..";
	}

	75% {
		content: "Loading...";
	}
`;
export const LoadingDot = styled.section`
	width: var(--loaderWidth);
	height: var(--loaderDotSize);
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	display: flex;
    align-items: center;

	.loaderdot {
		animation: loader 3s ease-in-out infinite;
		height: var(--loaderDotSize);
		width: var(--loaderDotSize);
		border-radius: 100%;
		background-color: black;
		position: absolute;

		&:first-child {
			background-color: #8cc759;
			animation-delay: 0.5s;
		}

		&:nth-child(2) {
			background-color: #8c6daf;
			animation-delay: 0.4s;
		}

		&:nth-child(3) {
			background-color: #ef5d74;
			animation-delay: 0.3s;
		}

		&:nth-child(4) {
			background-color: #f9a74b;
			animation-delay: 0.2s;
		}

		&:nth-child(5) {
			background-color: #60beeb;
			animation-delay: 0.1s;
		}

		&:nth-child(6) {
			background-color: #fbef5a;
			animation-delay: 0s;
		}
	}

	.loaderText {
		position: absolute;
		top: 200%;
		left: 0;
		right: 0;
		width: 4rem;
		margin: auto;
		color: #fff;

		&:after {
			content: "Loading";
			font-weight: bold;
			animation: ${LoadingText} 3s infinite;
		}
	}

	@keyframes showHoney {
		0% {
			opacity: 0;
			transform: translate(0, -100%);
		}
		100% {
			opacity: 1;
			transform: translate(0, 0);
		}
	}

	@keyframes loader {
		15% {
			transform: translateX(0);
		}

		45% {
			transform: translateX(calc(var(--loaderWidth) - var(--loaderDotSize)));
		}

		65% {
			transform: translateX(calc(var(--loaderWidth) - var(--loaderDotSize)));
		}

		95% {
			transform: translateX(0);
		}
	}
`;
